import { Injectable } from '@angular/core';
import { GenericService } from '../../../../core/services/GenericService';
import { IAttendee, IEvent } from '../interfaces';
import { ApiService } from '../../../../core/services';
import { Observable } from 'rxjs';
import { ITableResults } from '../../../../core/interfaces';
import { HttpUtils } from '../../../../core/utils/HttpUtils';

@Injectable({
  providedIn: 'root'
})
export class SeminarsAttendeesService extends GenericService<IAttendee> {

  protected baseUrl: string;

  private _seminarEventId: number;

  public constructor(
    public readonly apiService: ApiService
  ) {
    super(apiService);
  }

  public set seminarEventId(value: number) {
    this._seminarEventId = value;
    this.baseUrl = this._seminarEventId
      ? `/seminars/events/${ this._seminarEventId }/attendees`
      : `/seminars/events/attendees`;
  }

  public moveAttendeeToWaitingRoom(attendeeId: number): Observable<void> {
    return this.apiService.post(`/seminars/events/attendees/${ attendeeId }/move`);
  }

  public moveAttendeeToNewEvent(attendeeId: number, newSeminarEventId: string): Observable<void> {
    return this.apiService.post(`/seminars/events/attendees/${ attendeeId }/move`, { newSeminarEventId });
  }

  public resendAgbsMail(attendeeId: number): Observable<void> {
    return this.apiService.post(`/seminars/events/attendees/${ attendeeId }/resend-agbs-mail`);
  }

  public getAllAttendeesWithoutSeminars(pageIndex: number,
                  pageSize: number,
                  sortField: string | null,
                  sortOrder: string | null,
                  filters: Array<{ key: string; value: string[] }>,
                  search: Array<{ key: string; value: string[] }>,
                  additionalFilters: Array<{ key: string; value: string[] }>
  ): Observable<ITableResults<IAttendee>> {
    additionalFilters.push({key: 'OnlyWithoutSeminar', value: ['true']});
    const params = HttpUtils.prepareQueryableParams(pageIndex, pageSize, sortField, sortOrder, filters, search, additionalFilters);
    return this.apiService.get(`/seminars/events/attendees`, params );
  }
}
